import { Component, Input, OnInit } from '@angular/core';

import { UbiMsgCenterService } from './ubiMsgCenter.service';

@Component({
  selector: 'ubi-msg-center',
  providers: [UbiMsgCenterService],
  styleUrls: ['./ubiMsgCenter.scss'],
  templateUrl: './ubiMsgCenter.html'
})
export class UbiMsgCenter implements OnInit {

  @Input() options: any;

  public notifications: Array<Object>;
  public messages: Array<Object>;

  constructor(private _ubiMsgCenterService: UbiMsgCenterService) {
    this.notifications = this._ubiMsgCenterService.getNotifications();
    this.messages = this._ubiMsgCenterService.getMessages();
  }

  ngOnInit() {
    const defaultOptions = {
      notifications: false,
      messages: false,
    };

    this.options = Object.assign(defaultOptions, this.options);
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiMsgCenter/ubiMsgCenter.component.ts